import React from "react";

const API = ["localhost", "127.0.0.1"].includes(window.location.hostname) ? process.env.REACT_APP_BACKEND_URL : window.location.origin;
let sent = 0;

export function reportError(message, stack, source) {
  if (sent >= 5) return;
  sent += 1;
  try {
    const body = JSON.stringify({ message: String(message || "Unknown error").slice(0, 500), stack: String(stack || "").slice(0, 3000), source, url: window.location.href.slice(0, 300) });
    fetch(`${API}/api/track/error`, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
  } catch (e) {
    // reporting must never break the page
  }
}

export function installErrorReporting() {
  window.addEventListener("error", (e) => {
    if (e.message && e.message.includes("PerformanceServerTiming")) return;
    reportError(e.message, e.error && e.error.stack, "window");
  });
  window.addEventListener("unhandledrejection", (e) => {
    const r = e.reason || {};
    reportError(r.message || String(r), r.stack, "promise");
  });
}

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    reportError(error && error.message, `${(error && error.stack) || ""}\n${(info && info.componentStack) || ""}`, "react");
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24, background: "#071426", color: "#fff", fontFamily: "Inter, -apple-system, sans-serif", textAlign: "center" }} data-testid="app-error-fallback">
        <div style={{ maxWidth: 420 }}>
          <p style={{ fontSize: 28, fontWeight: 700, letterSpacing: "0.28em" }}>FAD</p>
          <p style={{ marginTop: 16, fontSize: 18 }}>Something went wrong while loading the page.</p>
          <p style={{ marginTop: 8, color: "rgba(255,255,255,0.65)", fontSize: 14 }}>Please reload, or contact us directly to book your briefing.</p>
          <button onClick={() => window.location.reload()} style={{ marginTop: 24, padding: "12px 24px", borderRadius: 999, background: "#fff", color: "#0B1F3A", fontWeight: 600, border: 0 }}>Reload page</button>
          <p style={{ marginTop: 20 }}><a href="https://wa.me/971501242886" style={{ color: "#C7A76C" }}>WhatsApp +971 50 124 2886</a></p>
        </div>
      </div>
    );
  }
}
